import showSwalAlert from 'src/util/alerts'

const mixinPermissions = {
    methods: {
      isSuper() {
        return this.$store.state.auth.permissions.includes('Super Administrador')
      },
  
      canIndex() {
        return this.isSuper() || this.$store.state.auth.permissions.includes('Indexar')
      },
  
      canShow() {
        return this.isSuper() || this.$store.state.auth.permissions.includes('Visualizar')
      },
  
      canCreate() {  
        return this.isSuper() || this.$store.state.auth.permissions.includes('Crear')
      },
  
      canUpdate() {
        return this.isSuper() || this.$store.state.auth.permissions.includes('Editar')
      },
  
      canDelete() {
        return this.isSuper() || this.$store.state.auth.permissions.includes('Borrar')
      },
  
      canPDF() {
        return this.isSuper() || this.$store.state.auth.permissions.includes('Exportar PDF')
      },
  
      canExcel() {
        return this.isSuper() || this.$store.state.auth.permissions.includes('Exportar Excel')
      },
  
      canDepartment() {
        return this.isSuper() || this.$store.state.auth.permissions.includes('Gestionar Departamentos')
      },
  
      canRoles() {
        return this.isSuper() || this.$store.state.auth.permissions.includes('Gestionar Perfiles')
      },
  
      canRol() {
        return this.isSuper() || this.$store.state.auth.permissions.includes('Gestionar Perfil')
      },
  
      canPermissions() {
        return this.isSuper() || this.$store.state.auth.permissions.includes('Gestionar Permisos')
      },
      
      canTemporary() {
        return this.isSuper() || this.$store.state.auth.permissions.includes('Gestionar Contraseña Temporal')
      },

      showMessageAccess() {
        showSwalAlert(
          'No tienes permisos para entrar a la dirección suministrada.',
          'warning'
        ).then(() => {
          this.$router.go(-1)
        });
      }
    }
  }
  
  export default mixinPermissions